import { render, staticRenderFns } from "./IconfontNew.vue?vue&type=template&id=9118da72"
import script from "./IconfontNew.vue?vue&type=script&lang=js"
export * from "./IconfontNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports